export enum Roles {
    WORKFLOW = "TELA_WORKFLOW",
    IMPORTACAO = "TELA_IMPORTACAO",
    GESTAO_USUARIO = "TELA_GESTAO_USUARIO",
    PLANO_ATIVIDADE = "TELA_PLANO_ATIVIDADE",
    GESTAO_CALENDARIO = "TELA_GESTAO_CALENDARIO",
    HISTORICO_IMPORTACAO = "TELA_HISTORICO_IMPORTACAO",
    ASSOCIACAO_ATIVIDADE_PROFESSOR = "TELA_ASSOCIACAO_ATIVIDADE_PROFESSOR",
    PARAMETRIZACAO_PLANO_ATIVIDADE = "TELA_PARAMETRIZACAO_PLANO_ATIVIDADE",
    ASSOCIACAO_PROFESSOR_COORDENADOR = "TELA_ASSOCIACAO_PROFESSOR_COORDENADOR",
    GESTAO_PERMISSAO_PLANO_ATIVIDADE = "TELA_GESTAO_PERMISSAO_PLANO_ATIVIDADE",
    GESTAO_ABONO_LEGAL = "TELA_GESTAO_ABONO_LEGAL",
    PLANO_ATIVIDADE_SELECAO_PROFESSOR = "TELA_PLANO_ATIVIDADE_SELECAO_PROFESSOR",
    AGENDA_DOCENTE = "TELA_AGENDA_DOCENTE",
    EDITAR_AGENDA_DOCENTE = "TELA_EDITAR_AGENDA_DOCENTE",
    VISUALIZAR_AGENDA_DOCENTE = "TELA_VISUALIZAR_AGENDA_DOCENTE",
    VISUALIZAR_PLANO_ATIVIDADE = "TELA_VISUALIZAR_PLANO_ATIVIDADE",
    PLANO_ATIVIDADE_DOCENTE = "TELA_PLANO_ATIVIDADE_DOCENTE",
    EDITAR_PLANO_ATIVIDADE_DOCENTE = "TELA_EDITAR_PLANO_ATIVIDADE_DOCENTE",
    PARAMETRIZACAO_CHECKIN = "TELA_PARAMETRIZACAO_CHECKIN",
    GESTAO_WORKFLOW = "TELA_GESTAO_WORKFLOW",
    RELATORIOS = "TELA_RELATORIOS",
    HELP = "UPLOAD_DOCUMENTO_HELP",
    TERMO_ACEITE = "TELA_TERMO_ACEITE",
    ADMINISTRADOR_TACH = "TELA_ADMINISTRADOR_TACH",
    HISTORICO_TACH = "TELA_HISTORICO_TACH",
    HOME = "TELA_HOME",
    MEU_PAINEL_MENU = "MENU_MEU_PAINEL",
    MEU_PAINEL_DOCENTE = "TELA_MEU_PAINEL_DOCENTE",
}

const roleValues: { [role in Roles]: number } = {
    [Roles.WORKFLOW]: 0,
    [Roles.IMPORTACAO]: 1,
    [Roles.GESTAO_USUARIO]: 2,
    [Roles.PLANO_ATIVIDADE]: 3,
    [Roles.GESTAO_CALENDARIO]: 4,
    [Roles.HISTORICO_IMPORTACAO]: 5,
    [Roles.ASSOCIACAO_ATIVIDADE_PROFESSOR]: 6,
    [Roles.PARAMETRIZACAO_PLANO_ATIVIDADE]: 7,
    [Roles.ASSOCIACAO_PROFESSOR_COORDENADOR]: 8,
    [Roles.GESTAO_PERMISSAO_PLANO_ATIVIDADE]: 9,
    [Roles.PLANO_ATIVIDADE_SELECAO_PROFESSOR]: 10,
    [Roles.AGENDA_DOCENTE]: 11,
    [Roles.EDITAR_AGENDA_DOCENTE]: 12,
    [Roles.VISUALIZAR_AGENDA_DOCENTE]: 13,
    [Roles.VISUALIZAR_PLANO_ATIVIDADE]: 14,
    [Roles.PLANO_ATIVIDADE_DOCENTE]: 15,
    [Roles.EDITAR_PLANO_ATIVIDADE_DOCENTE]: 16,
    [Roles.PARAMETRIZACAO_CHECKIN]: 18,
    [Roles.GESTAO_ABONO_LEGAL]: 19,
    [Roles.GESTAO_WORKFLOW]: 20,
    [Roles.RELATORIOS]: 21,
    [Roles.HELP]: 22,
    [Roles.TERMO_ACEITE]: 23,
    [Roles.ADMINISTRADOR_TACH]: 24,
    [Roles.HISTORICO_TACH]: 25,
    [Roles.HOME]: 26,
    [Roles.MEU_PAINEL_MENU]: 27,
    [Roles.MEU_PAINEL_DOCENTE]: 28,
};

export const getRoleValue = (role: Roles): number => roleValues[role];
